/**
 * Функция для генерации события в натив о том, что во время загрузки ФВУ произошли ошибки
 * @param label уникальный лейбл ошибки, который позволит apps определить что пошло не так
 * @returns событие для нативного приложения
 */
export const generateOnloadErrorAction = (label: string) => ({
  action: 'onload-error',
  payload: { label },
});
